import React from 'react';
import DateComponentProps from './types';
import FormComponent from '../FormComponent';

const DateComponent: React.FC<DateComponentProps> = ({
    name,
    label,
    required,
    formData,
    inputRef,
    disablePast,
    topTooltip,
    bottomTooltip,
    leftTooltip,
    rightTooltip,
    display
}) => {
    return (
        <FormComponent
            name={name}
            label={label}
            required={required}
            formData={formData}
            topTooltip={topTooltip}
            bottomTooltip={bottomTooltip}
            leftTooltip={leftTooltip}
            rightTooltip={rightTooltip}
            display={display}
        >
            <input
                type="date"
                className={`form-control`}
                id={name}
                ref={inputRef}
                min={disablePast ? (new Date()).toISOString().split('T')[0] : '0000-00-00'}
                {...formData.getFieldProps(name)}
            />
        </FormComponent>
    );
};

export default DateComponent;
